"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserActionControl = exports.SpecialAssertion = exports.ResponseItemType = exports.NameAssertion = exports.MessageType = exports.GroupType = exports.FormLevelFeatureType = exports.FieldType = exports.EventAssertion = exports.CategoryBucketTypes = void 0;
let GroupType = exports.GroupType = /*#__PURE__*/function (GroupType) {
  GroupType["Name"] = "name";
  GroupType["FamilyMember"] = "familyMember";
  GroupType["Event"] = "event";
  GroupType["Hierarchical"] = "hierarchical";
  GroupType["Special"] = "special";
  GroupType["Other"] = "other";
  return GroupType;
}({});
let ResponseItemType = exports.ResponseItemType = /*#__PURE__*/function (ResponseItemType) {
  ResponseItemType["FeatureContainer"] = "featureContainer";
  ResponseItemType["FieldGroup"] = "fieldGroup";
  return ResponseItemType;
}({});
let UserActionControl = exports.UserActionControl = /*#__PURE__*/function (UserActionControl) {
  UserActionControl["Calc"] = "calc";
  UserActionControl["Exact"] = "exact";
  return UserActionControl;
}({});
let SpecialAssertion = exports.SpecialAssertion = /*#__PURE__*/function (SpecialAssertion) {
  SpecialAssertion["Race"] = "Race";
  SpecialAssertion["Gender"] = "Gender";
  SpecialAssertion["CategoryBucket"] = "CategoryBucket";
  SpecialAssertion["Keyword"] = "keyword";
  SpecialAssertion["Priority"] = "Priority";
  SpecialAssertion["LimitToCountry"] = "LimitToCountry";
  SpecialAssertion["Search"] = "Search";
  SpecialAssertion["Clear"] = "Clear";
  SpecialAssertion["ShowAdvanced"] = "ShowAdvanced";
  SpecialAssertion["Year"] = "Year";
  SpecialAssertion["Place"] = "Place";
  return SpecialAssertion;
}({});
let FieldType = exports.FieldType = /*#__PURE__*/function (FieldType) {
  FieldType["LimitedValues"] = "limitedValues";
  FieldType["PlaceLimitedValues"] = "placeLimitedValues";
  FieldType["ValueRange"] = "valueRange";
  FieldType["Integer"] = "integer";
  FieldType["String"] = "string";
  FieldType["Place"] = "place";
  FieldType["Year"] = "year";
  FieldType["YearRange"] = "yearRange";
  return FieldType;
}({});
/** A labeled set of fields — the atomic grouping unit for fieldset-based groups. */
/** Fieldset-based group — Event, FamilyMember. */
let NameAssertion = exports.NameAssertion = /*#__PURE__*/function (NameAssertion) {
  NameAssertion["GivenName"] = "GivenName";
  NameAssertion["Surname"] = "Surname";
  NameAssertion["SecondSurname"] = "SecondSurname";
  return NameAssertion;
}({});
/** @deprecated Use FamilyRelation instead. */
let EventAssertion = exports.EventAssertion = /*#__PURE__*/function (EventAssertion) {
  EventAssertion["Day"] = "Day";
  EventAssertion["Month"] = "Month";
  EventAssertion["Year"] = "Year";
  EventAssertion["Place"] = "Place";
  return EventAssertion;
}({});
/** @deprecated Use FieldRelation instead. */
let MessageType = exports.MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Err"] = "err";
  MessageType["Warn"] = "warn";
  MessageType["Info"] = "info";
  return MessageType;
}({});
let FormLevelFeatureType = exports.FormLevelFeatureType = /*#__PURE__*/function (FormLevelFeatureType) {
  FormLevelFeatureType["CollapsibleView"] = "collapsibleView";
  FormLevelFeatureType["CollapsibleStart"] = "collapsibleStart";
  FormLevelFeatureType["CollapsibleEnd"] = "collapsibleEnd";
  FormLevelFeatureType["Message"] = "message";
  FormLevelFeatureType["MatchAllTerms"] = "matchAllTerms";
  FormLevelFeatureType["UnviewedRecords"] = "unviewedRecords";
  FormLevelFeatureType["RotatedRecords"] = "rotatedRecords";
  FormLevelFeatureType["CategoryBuckets"] = "categoryBuckets";
  FormLevelFeatureType["SubmitBtn"] = "submitBtn";
  FormLevelFeatureType["ClearBtn"] = "clearBtn";
  FormLevelFeatureType["AdvancedSearchLink"] = "advancedSearchLink";
  FormLevelFeatureType["LimitToCountry"] = "limitToCountry";
  FormLevelFeatureType["CollectionFocus"] = "collectionFocus";
  FormLevelFeatureType["ShowUnviewedRecordsOnly"] = "showUnviewedRecordsOnly";
  FormLevelFeatureType["SearchAssistModal"] = "searchAssistModal";
  return FormLevelFeatureType;
}({});
/* Ala-carte specific type definitions - TO-DO: Move out of this file */
let CategoryBucketTypes = exports.CategoryBucketTypes = /*#__PURE__*/function (CategoryBucketTypes) {
  CategoryBucketTypes["Records"] = "records";
  CategoryBucketTypes["Stories"] = "stories";
  CategoryBucketTypes["Trees"] = "trees";
  CategoryBucketTypes["Photos"] = "photos";
  return CategoryBucketTypes;
}({});